var _circle, _circle2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCsFailed({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Status",
    xmlns: "http://www.w3.org/2000/svg",
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16",
    "data-name": "Ellipse 16",
    cx: 23,
    cy: 23,
    r: 23,
    fill: "#e1e7e9"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_11",
    "data-name": "Ellipse 11",
    cx: 20,
    cy: 20,
    r: 20,
    transform: "translate(3 3)",
    fill: "#9e1b32"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "x_circle_stroke",
    "data-name": "x circle stroke",
    transform: "translate(16.097 16.1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M.182,13.624a.532.532,0,0,0,.4.174.542.542,0,0,0,.435-.174L6.908,7.73l5.874,5.894a.542.542,0,0,0,.406.174.532.532,0,0,0,.406-.174.552.552,0,0,0,0-.8L7.7,6.917l5.894-5.874a.571.571,0,1,0-.8-.8l-5.9,5.894L1.014.211a.571.571,0,1,0-.8.8L6.1,6.908l-5.894,5.9a.552.552,0,0,0,0,.8",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.75
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCsFailed);
export default __webpack_public_path__ + "static/media/icon_cs_failed.4c156a5d1bb9392c42466f52b01ac40e.svg";
export { ForwardRef as ReactComponent };